/**
 * Configuration for nutritionist assignment rules
 * 
 * This configuration defines:
 * - Which nutritionists to exclude from random assignment
 * - Force assignment rules for specific users
 * - Fallback behavior when preferred experts are not available
 */

export const NUTRITIONIST_ASSIGNMENT_CONFIG = {
  // Nutritionists to exclude from random assignment
  excludedEmails: ["fabiana.nutrizionista@gmail.com"],
  
  // Force assignments for specific users
  forceAssignments: [
    {
      userIds: [
        "c3a4a842-5091-709a-8345-7c76c610ec64",
        "435478d2-9001-7022-6fab-86497fb3da73",
      ],
      preferredEmail: "carolinacolonna94@gmail.com",
      fallbackToRandom: true, // If preferred expert not found, fall back to random
      description: "Force Carolina for specific test users",
    },
    // Add more force assignment rules here as needed
    // {
    //   userIds: ["another-user-id"],
    //   preferredEmail: "another-expert@email.com",
    //   fallbackToRandom: true,
    //   description: "Force specific expert for specific users",
    // },
  ],
};

/**
 * Types for the configuration
 */
export interface ForceAssignmentRule {
  userIds: string[];
  preferredEmail: string;
  fallbackToRandom: boolean;
  description: string;
}

export interface NutritionistAssignmentConfig {
  excludedEmails: readonly string[];
  forceAssignments: readonly ForceAssignmentRule[];
}

/**
 * Helper function to check if a user has a force assignment
 */
export const getUserForceAssignment = (userId: string): ForceAssignmentRule | undefined => {
  return NUTRITIONIST_ASSIGNMENT_CONFIG.forceAssignments.find(
    rule => rule.userIds.includes(userId)
  );
};

/**
 * Helper function to check if an email is excluded
 */
export const isEmailExcluded = (email: string): boolean => {
  return NUTRITIONIST_ASSIGNMENT_CONFIG.excludedEmails.includes(email);
}; 